import styled from "styled-components";
import InputField from "../InputField";
import { FormControl as MUIFormControl } from "@material-ui/core";
import { TextareaAutosize as MUITextareaAutosize } from "@material-ui/core";

export const CustomInputField = styled(InputField)`
  border: 1px solid #c9d4db;
  border-radius: 3px;
  background-color: #ffffff !important;
  height: 49px !important;
`;

export const FormWrapper = styled.div`
  width: 96%;

  div {
    background-color: #ffffff;
  }

  span {
    color: #f21500;
    font-size: 11px;
    margin-left: 14px;
  }
`;

export const TextareaAutosize = styled(MUITextareaAutosize)`
  border: 1px solid #c9d4db;
  border-radius: 7px;
  background-color: #ffffff !important;
  height: 49px !important;
`;

export const FormControl = styled(MUIFormControl)`
  border: 1px solid #c9d4db;
  border-radius: 7px;
  background-color: #ffffff !important;
  height: 49px !important;
`;
